<template>
  <div class="container-fluid">
    <div class="header mt-3 mt-md-0">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h6 class="header-pretitle">
              설정
            </h6>
            <h1 class="header-title">
              {{ centerAccount.name }}
            </h1>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col">
            <ul class="nav nav-tabs nav-overflow header-tabs">
              <li
                v-for="subMenu in subMenus"
                class="nav-item nav-link"
                :class="{'active': subMenu.value === curSubMenu}"
                @click="handleClickSubMenu(subMenu)"
              >
                {{ subMenu.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-6">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { computedGetters } from '@/utils/vuex-helper';
import { ACCOUNT_ROLE } from '@/constants';

import FiflFooter from '../../components/FiflFooter';

export default {
  name: 'Setting',
  components: { FiflFooter },
  data() {
    return {
      subMenus: [
        {
          value: 'policy',
          name: '운영 정책'
        },
        {
          value: 'course',
          name: '수업'
        },
        {
          value: 'membership',
          name: '회원권'
        },
        {
          value: 'instructor',
          name: '강사'
        }
      ],
      curSubMenu: 'policy'
    };
  },
  computed: {
    ...computedGetters(['role', 'isSettingMenuVisible']),
    ...mapGetters({
      centerAccount: 'getCenterAccount'
    })
  },
  watch: {
    $route: {
      immediate: true,
      handler(value) {
        let curPage = value.name.split('/')[2];
        this.curSubMenu = curPage;
      }
    },
    role: {
      immediate: true,
      handler: function(value) {
        if (value === ACCOUNT_ROLE.INSTRUCTOR) {
          this.subMenus = this.subMenus.slice(0, 3);
        }
      }
    },
    isSettingMenuVisible: {
      immediate: true,
      handler: function(isAccessAllowed) {
        if (!isAccessAllowed) {
          this.$router.push('/announce/access-block').catch(() => {});
        }
      }
    }
  },
  created() {
    this.$store.dispatch('syncParentMembershipCategories');
  },
  methods: {
    handleClickSubMenu({ value }) {
      this.$router.push('/setting/' + value).catch(() => {});
    }
  }
};
</script>

<style lang="scss">
.el-tabs {
  margin-top: 23px;
  .el-tabs__header {
    margin: 0;
  }
}
.confirm-booking {
  border-radius: 8px;
  background-color: #f2f2f2;
  height: 177px;
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;

  li {
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 20px;
    height: 20px;
    letter-spacing: -0.8px;
    color: #9b9b9b;

    span:first-child {
      display: inline-block;
      width: 143px;
      line-height: 27px;
      height: 27px;
      vertical-align: top;
      margin-right: 7px;
    }

    span:last-child {
      display: inline-block;
      width: calc(100% - 153px);
      height: 27px;
      line-height: 27px;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: normal;
      overflow: hidden;
      vertical-align: top;
    }
  }
}
</style>
